import i18n from "../../../AppSystem/i18n";
import * as yup from "yup";
import { string } from "yup";

class AdminRequestApiKeyCreate {
    constructor({
                    name = '',
                    expiresAt = null,
                } = {}) {
        this.name = name;
        this.expiresAt = expiresAt;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const fieldRequired = `${i18n.t('validationMessage.fieldRequired')}`;

        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        // SCHEMA
        const completeSchema = yup.object().shape({
            name: string().trim().required(fieldRequired).max(100, i18n.t('apiKey.nameMaxLength')),
            expiresAt: yup.date().nullable(),
        });

        const attributes = {
            name: {
                'form': {
                    'type': 'text',
                    'placeholder': i18n.t('apiKey.namePlaceholder'),
                    'validation': completeSchema.fields.name,
                },
                'value': (item) => item.name || "",
            },
            expiresAt: {
                'id': 'expiresAt',
                'form': {
                    'type': 'date',
                    'placeholder': i18n.t('apiKey.never'),
                    'validation': completeSchema.fields.expiresAt,
                    'minDate': tomorrow,
                    // The form lives in a SlidePanel, render the calendar outside it so it is not clipped
                    'portalId': 'api-key-datepicker-portal',
                },
                'value': (item) => item.expiresAt || "",
            },
        };

        if (validationSchema === true) {
            return completeSchema;
        }

        return attributes;
    }
}

export default AdminRequestApiKeyCreate;
